import React, {Component} from "react";
import {Redirect} from "react-router-dom";

class TopLineSearch extends Component {

	state = {
		text     : '',
		isSubmit : false,
	};

	onChange(e) {
		this.setState({
			text : e.target.value
		});
	}

	onKeyDown(e) {
		if ( e.keyCode === 13 ) {
			this.setState({
				isSubmit : true
			});
		}
	}

	render() {
		if ( this.state.isSubmit ) {
			return <Redirect to={{
				pathname : '/search',
				text     : this.state.text
			}}/>
		}

		return (
			<div className="topline__search">
				<div className="search">
					<i className="search__icon fa fa-search"></i>
					<input className="search__input" type="text" placeholder="Поиск по событиям"
					       onChange={this.onChange.bind(this)}
					       onKeyDown={this.onKeyDown.bind(this)}
					       value={this.state.text}/>
				</div>
			</div>
		);
	}
}

export default TopLineSearch;


// WEBPACK FOOTER //
// ./src/app/pages/Main/TopLine/TopLineSearch.js